// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__k9OEa","label":"Category_label__3LXRC","content":"Category_content__1eMXq","header":"Category_header__3aMpx","location":"Category_location__3BVXb"};